/**
 * Set up routing for all Question views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import question views
import CreateSentimentQuestion from './views/CreateSentimentQuestion.js.jsx';
import SentimentQuestionList from './views/SentimentQuestionList.js.jsx';
import SingleSentimentQuestion from './views/SingleSentimentQuestion.js.jsx';
import UpdateSentimentQuestion from './views/UpdateSentimentQuestion.js.jsx';

class SentimentQuestionRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute 
          breadcrumbs={[{display: 'All Sentiment Questions', path: null}]}
          login={true} 
          exact 
          path="/admin/sentiment-questions" 
          component={SentimentQuestionList} 
        />
        <YTRoute 
          login={true} 
          exact 
          path="/admin/sentiment-questions/new" 
          component={CreateSentimentQuestion} 
        />
        <YTRoute 
          breadcrumbs={[{display: 'All Sentiment Questions', path: '/admin/sentiment-questions'}, {display: 'Single Sentiment Question', path: null}]}
          login={true}
          exact 
          path="/admin/sentiment-questions/:sentimentQuestionId" 
          component={SingleSentimentQuestion}
        />
        <YTRoute 
          login={true} 
          exact 
          path="/admin/sentiment-questions/:sentimentQuestionId/update" 
          component={UpdateSentimentQuestion}
        />
      </Switch>
    )
  }
}

export default SentimentQuestionRouter;



// WEBPACK FOOTER //
// modules/sentimentQuestion/SentimentQuestionRouter.js.jsx